<template>
  <v-container>
      <v-toolbar flat>
        <v-row>
          <span class="font-weight-light" style="font-size: 16pt">
            {{ $t('label.newCapture') }}
          </span>
          <v-spacer>
          </v-spacer>
          <v-btn
            color="secondary"
            class="mx-1"
            @click.stop="downloadReport()"
            >
            <v-icon>
              mdi-download
            </v-icon>
            {{ $t('label.downloadReport') }}
          </v-btn>
          <v-btn
            color="primary"
            @click.stop="downloadOpenLines()"
            class="mx-1"
            >
            <v-icon>
              mdi-download
            </v-icon>
            {{ $t('label.downloadTemplate') }}
          </v-btn>
          <v-btn
            color="primary"
            @click.stop="openUploadDialog()"
            class="mx-1"
            >
            <v-icon>
              mdi-upload
            </v-icon>
            {{ $t('label.uploadTemplate') }}
          </v-btn>
        </v-row>
      </v-toolbar>
    <v-row>
      <v-col cols="12">
        <new-capture-form></new-capture-form>
      </v-col>
    </v-row>

    <v-dialog v-model="isUploadFileDialogOpen" max-width="600" persistent>
      <v-card>
        <v-card-title>
          <v-row justify="space-between">
            <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.uploadOpenLines') }}</span>
              <v-btn icon @click.stop="isUploadFileDialogOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <file-drop
            @filesSelected="filesSelected"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            extensions="xls,xlsx"
            >
          </file-drop>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isExcelValidatedDialogOpen" max-width="1200" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5">
          {{ importedSuccess ? $t('label.preview') : $t('label.errorsAtImportedFile') }}
        </v-card-title>
        <v-card-text style="height: 500px;">
          <v-data-table
            :items="excelValidated"
            :headers="headers"
            hide-default-footer
            >
            <template v-slot:[`item.lineStatus`]="{ item }">
              <v-chip
                v-if="item.lineStatus"
                color="green"
                >
                {{ $t('label.valid') }}
              </v-chip>
              <v-chip
                v-else
                color="red"
                >
                {{ $t('label.invalid') }}
              </v-chip>
            </template>
            <template v-slot:[`item.errorMessage`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs">
                    {{ item.errorMessage }}
                  </span>
                </template>
                <span>{{ item.errorMessage }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="isExcelValidatedDialogOpen = false"
            >
            {{ $t('label.close') }}
          </v-btn>
          <v-btn
            v-if="importedSuccess"
            color="primary"
            @click="confirmUpload"
            >
            {{ $t('label.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { loading, showMessage } from '../../mixins'
import { saveAs } from 'file-saver'
import NewCaptureForm from '../../components/EDI/shipments/NewCaptureForm'
import FileDrop from '../../components/Shared/FileDrop'

export default {
  name: 'NewCapturePage',
  components: { NewCaptureForm, FileDrop },
  mixins: [loading, showMessage],
  data: () => ({
    isUploadFileDialogOpen: false,
    isExcelValidatedDialogOpen: false,
    filesToUpload: [],
    excelValidated: [],
    importedSuccess: true
  }),
  computed: {
    headers () {
      return [
        { text: 'Status', value: 'lineStatus', align: 'center', sortable: false },
        { text: 'Error', value: 'errorMessage', align: 'center', sortable: false },
        { text: this.$t('label.purchaseOrder'), value: 'purchaseOrder', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.line'), value: 'line', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.partNumber'), value: 'partNumber', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.quantityToShip'), value: 'quantityToShip', align: 'center', sortable: true, filterable: true },
        { text: 'SNP', value: 'snp', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.tentativeDeliveryDate'), value: 'formattedTentativeDeliveryDate', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.shipmentDate'), value: 'formattedShipmentDate', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.invoice'), value: 'invoice', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.vendorOrder'), value: 'vendorOrder', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.lot'), value: 'lot', align: 'center', sortable: true, filterable: true }
      ]
    }
  },
  methods: {
    downloadReport () {
      this.$proxy.getDownload('api/edi/openLinesReport')
        .then(res => {
          saveAs(res.data, 'OpenLinesReport.xlsx')
        })
        .catch(e => {
          this.showHttpErrorMessage(e)
        })
    },
    downloadOpenLines () {
      this.changeLoadingStatus(true)
      this.$proxy.getDownload('api/edi/openLines')
        .then((r) => {
          const now = new Date()
          const fileName = `kasairelease_${now.toISOString().replace(/\D+/g, '')}.xlsx`
          saveAs(r.data, fileName)
        })
        .catch((e) => {
          console.log(e)
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    uploadOpenLines () {
      const formData = new FormData()
      formData.append('file', this.filesToUpload)
      this.$proxy.post('api/edi/openlines/upload', formData)
        .then(res => {
          this.excelValidated = res.data
          this.isExcelValidatedDialogOpen = true
          this.importedSuccess = this.excelValidated.every(x => x.lineStatus)
        })
        .catch(e => {
          this.showHttpErrorMessage(e)
        })
        .finally(_ => {
          this.isUploadFileDialogOpen = false
        })
    },
    openUploadDialog () {
      this.isUploadFileDialogOpen = true
    },
    filesSelected (files) {
      this.filesToUpload = files
      this.uploadOpenLines()
    },
    confirmUpload () {
      this.$proxy.post('api/edi/openlines/confirmupload', this.excelValidated)
        .then(_ => {
          this.showMessage(this.$t('message.success.shipmentCaptureSaved'))
        })
        .catch(e => {
          this.showHttpErrorMessage(e)
        })
        .finally(_ => {
          this.isExcelValidatedDialogOpen = false
        })
    }
  }
}
</script>

<style>

</style>
